module.exports = __webpack_public_path__ + "static/media/Frame 2008.7dc99d18.svg";